import React, { useState, useEffect } from "react";
import {
  Container,
  Wrapper,
  StyledLink,
  StyledAnchorLink,
  Icon,
  Text,
} from "./styles";
import { useCaseData } from "shared/Hooks/CasesNew/useCaseData";

export const Navigation = ({ color, type }) => {
  const data = useCaseData();
  const [prevUrl, setPrevUrl] = useState(null);
  const [nextUrl, setNextUrl] = useState(null);

  useEffect(() => {
    const keys_array = Object.keys(data);
    const current_index = keys_array.indexOf(type);
    const prev_index = keys_array[current_index - 1];
    const next_index = keys_array[current_index + 1];

    current_index - 1 >= 0
      ? setPrevUrl(data[prev_index].slug)
      : setPrevUrl(false);

    current_index + 1 >= keys_array.length
      ? setNextUrl(false)
      : setNextUrl(data[next_index].slug);
  }, [data, type]);

  return (
    <Container color={color}>
      <Wrapper>
        <StyledLink
          to={`/realizacje/${prevUrl}`}
          className={`prev ${prevUrl ? null : "disable"}`}
          title="Poprzedni projekt"
        >
          <Icon />
          <Text>Poprzedni projekt</Text>
        </StyledLink>
        <StyledAnchorLink
          to="/realizacje#lista"
          title="Wszystkie projekty"
          stripHash
        >
          <Text>Wszystkie projekty</Text>
        </StyledAnchorLink>
        <StyledLink
          to={`/realizacje/${nextUrl}`}
          className={`next ${nextUrl ? null : "disable"}`}
          title="Następny projekt"
        >
          <Icon />
          <Text>Następny projekt</Text>
        </StyledLink>
      </Wrapper>
    </Container>
  );
};
